import { Row } from 'react-table'
import { useTranslation } from 'react-i18next'

import { colors } from 'utils/colors'
import { FixMeAny } from 'types/global'

import Box from '../../Box'
import MenuOptions, { MenuDropdownProps } from '../../MenuOptions'

interface Props {
  row: Row<FixMeAny>
  isRowActive: boolean
  onEdit?: (item: FixMeAny) => void
  onActivate?: (item: FixMeAny) => void
  onDelete?: (item: FixMeAny) => void
  context: string
  children?: React.ReactNode
}

const OptionCell = ({ row, isRowActive, onEdit, onActivate, onDelete, context, children }: Props) => {
  const { t } = useTranslation()

  const showEdit = onEdit && isRowActive
  const showActivate = onActivate
  const showDelete = onDelete

  const hasActive = showEdit || showActivate || showDelete

  const options: MenuDropdownProps[] = [
    {
      handleClick: () => onEdit?.(row.original),
      icon: ['far', 'pencil'],
      label: t('edit_value_lbl', { value: t(context) }),
      value: 'edit',
      isDisabled: !isRowActive,
      isHidden: !showEdit,
    },
    {
      handleClick: () => onActivate?.(row.original),
      icon: isRowActive ? ['far', 'minus-octagon'] : ['far', 'repeat'],
      iconColor: isRowActive ? colors.red : undefined,
      label: isRowActive
        ? t('deactivate_value_lbl', { value: t(context) })
        : t('reactivate_value_lbl', { value: t(context) }),
      value: isRowActive ? 'deactivate' : 'reactivate',
      isHidden: !showActivate,
    },
    {
      handleClick: () => onDelete?.(row.original),
      color: colors.red,
      icon: ['far', 'trash-alt'],
      label: t('delete_value_lbl', { value: t(context) }),
      value: 'delete',
      isHidden: !showDelete,
    },
  ]

  if (!hasActive) return <></>

  return (
    <Box display="flex" justifyContent="space-between">
      <Box>{children}</Box>
      <MenuOptions options={options} isPortaled />
    </Box>
  )
}

export default OptionCell
